module.exports = __webpack_public_path__ + "img/application-title-m.fc601b5a.png";